const callbacks: (() => void)[] = [];

export function onDomContentLoaded(callback: () => void): void {
    if (document.readyState === 'loading') {
        if (callbacks.length === 0) {
            document.addEventListener('DOMContentLoaded', () => {
                for (const callback of callbacks) {
                    callback()
                }
            });
        }

        callbacks.push(callback);
    } else {
        callback();
    }
}
